import styled from 'styled-components';

import { Colour } from '@xemplo/colours';
import { BodySmallRegular } from '@xemplo/style-constants';

export {
  CardContainer,
  Header,
  IconWrapper,
  Title,
  Field,
  Label,
  Value,
} from '../shared/card-styles';

export const Tags = styled.div`
  color: ${Colour.Gray[400]};
  ${BodySmallRegular};
`;
